module.exports = require('buffer').Buffer.isBuffer;



//////////////////
// WEBPACK FOOTER
// ./~/vinyl/lib/isBuffer.js
// module id = 4051
// module chunks = 0